import { LocalStorageManager } from './LocalStorageManager'
import { RuntimeMajor } from '../../components/LogPoints/util/runtime/LogPointsRuntimeHelper'

export class LogPointsLocalStorage{
  constructor(
      public selectedEnvironment: string | null = null,
      public selectedResource: string | null = null,
      public selectedVersion: string | null = null,
      public runtimeSupport: {[key in RuntimeMajor]?: {support: string, expiration: number}} | null = null
  ){}
}

export class ReportsLocalStorage{
  constructor(public selectedBusinessGroup: string | null = null,
              public selectedEnvironment: string | null = null,
              public selectedType: string | null = null,
              public from: string | null = null,
              public to: string | null = null) {}
}

export class SelectedEnvironment{
  constructor(public selectedEnvironment: string | null = null) {}
}

export class SettingsLocalStorage{
  constructor(
      public cloudhub: SelectedEnvironment = new SelectedEnvironment(),
      public hybrid: SelectedEnvironment = new SelectedEnvironment(),
      public selectedCategory: string | null = null
  ) {}
}

export class RawDataLocalStorage {
  constructor(
      public selectedEnvironment: string | null = null,
      public selectedResource: string | null = null,
      public selectedResourceType: string | null = null
  ){}
}

export class Range{
  constructor(public from: string, public to: string) {}
}

export class AutoRefresh{
  constructor(public checked: boolean = false, public frequency: string | null = null) {}
}

export class BuiltInLocalStorage {
  constructor(
      public selectedEnvironment: string | null = null,
      public selectedResource: string | null = null,
      public selectedVersion: string | null = null,
      public dashboardType: string | null = null,
      public resourceType: string | null = null,
      public isDetailHidden: boolean | null = null,
      public range: Range | null = null,
      public autoRefresh: AutoRefresh = new AutoRefresh()
  ) {
  }
}

export class MonitoringLocalStorage {
  constructor(
      public  reports: ReportsLocalStorage = new ReportsLocalStorage(),
      public  logPoints: LogPointsLocalStorage = new LogPointsLocalStorage(),
      public  settings: SettingsLocalStorage = new SettingsLocalStorage(),
      public  builtIn: BuiltInLocalStorage = new BuiltInLocalStorage(),
      public  rawData: RawDataLocalStorage = new RawDataLocalStorage(),
  ) {
  }

}

export const monitoringLocalStorageInitialState: MonitoringLocalStorage = new MonitoringLocalStorage();

const MonitoringLocalStorageManager = new LocalStorageManager<MonitoringLocalStorage>('monitoring', {...monitoringLocalStorageInitialState})

export const isKeyOfMonitoringLocalStorage = (value: string): value is keyof MonitoringLocalStorage => {
  const keys = Object.keys(MonitoringLocalStorageManager.all())
  return keys.indexOf(value) >= 0
}

export default MonitoringLocalStorageManager
